import moment from 'moment';
import { useState } from 'react';

export const ColumnDeliveries = (translate, warning, langLocal) => {
    const [options, setOptions] = useState(false)
    const [row_id, setRowId] = useState(null)
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('request_date')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['request_date']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('received_by')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['received_by']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('location')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['location']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('created_at')}</span>,
            cell: (row) => (
                <span>{moment(row['created_at']).format("YYYY-MM-DD")}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row, index) => (
                <div  >
                    {/*<i className='fa fa-edit icon_edit' onClick={(e) => handleEdit(e, row)} ></i>
                    <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>*/}
                    <i className='fa fa-ellipsis-v icon_edit' onClick={() => { setOptions(!options); setRowId(index) }}  ></i>
                    {/*
                        options && index === row_id && (
                            <div className='div-actions shadow_main' >
                                <span >Create Delivery</span>
                                <span onClick={(e)=> showRequest(e,row.id)} >Details</span>
                                <span onClick={() => warning(row)} >Delete</span>
                            </div>
                        )
                    */}
                </div>
            )
        }
    ]
    return {
        columns
    }
}
